import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n      "]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
import { StyleSheetManager, css } from 'styled-components';
import ThemeContext from '@hzero-front-ui/core/lib/utils/ThemeContext';
import { getStyleSheetTarget, createStyleComponent, createMainStyleComponent } from '@hzero-front-ui/core';
import React, { useContext } from 'react';
import expandMenuCss from "./expandMenuCss";
import getCommonLayoutStyle from "./LayoutCommon";
import getLeftSideCalloutLayoutStyle from "./LeftSideCalloutLayout";
import getSideExpandLayoutCss from "./sideExpandLayout";
import getSideCascadeLayoutCss from "./sideCascadeLayout";
import getTopLayoutCss from "./topLayoutCss";
import getPlaneLayoutCss from "./planeLayout";
import globalOverride from "./GlobalOverride";
import HzeroGlobalStyle from "./HzeroGlobalStyle";
import getCommonCompStyle from "./commonCompStyle";
export { default as C7nPolyfill, baseCss as C7nBaseCss } from "./DefaultC7NPolyfill";
var LayoutMainComponent = createMainStyleComponent({
  name: 'hzero-layout',
  styles: [createStyleComponent('layout', css(_templateObject(), getCommonLayoutStyle, getSideExpandLayoutCss, getPlaneLayoutCss, getSideCascadeLayoutCss, getTopLayoutCss, expandMenuCss, globalOverride, getCommonCompStyle, getLeftSideCalloutLayoutStyle))]
});
var LayoutTheme = function LayoutTheme() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyleSheetManager, {
    target: getStyleSheetTarget('hzero-common-global-style')
  }, /*#__PURE__*/React.createElement(HzeroGlobalStyle, null)));
};
export var LayoutComponent = function LayoutComponent() {
  var _ref = useContext(ThemeContext) || {},
    schema = _ref.schema;
  return /*#__PURE__*/React.createElement(React.Fragment, null, schema !== 'peacock' && schema !== 'theme4' ? /*#__PURE__*/React.createElement(LayoutMainComponent, null) : null);
};
export default LayoutTheme;